import { KForm, KTextField } from "kinnect-general";

export default KForm.extend( {
	name: "KCustomerForm",

	props: {
		customer: Object,

		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "customers" } ]
		}
	},

	data: () => ( {
		formFields: {
			name: null,
			email: null
		},
		addresses: []
	} ),

	computed: {
		editing() {
			return Boolean( this.customer );
		},

		formUrl() {
			return this.editing
				? `sales/customers/${this.customer.id}`
				: "sales/customers";
		}
	},

	watch: {
		customer: {
			handler( customer ) {
				if ( customer ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( customer.hasOwnProperty( key ) ) {
							this.formFields[key] = customer[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				label="Name*"
				prependIcon="person"
				required
				vModel={this.formFields.name}
				validationName="name"
				validationRules="required"
			></KTextField>

			<KTextField
				label="Email"
				prependIcon="email"
				type="email"
				vModel={this.formFields.email}
				validationName="email"
				validationRules="email"
			></KTextField>
		</KForm>;
	}
} );
